import { render } from "./HHPreadmissionForm.vue?vue&type=template&id=f19138e6&ts=true"
import script from "./HHPreadmissionForm.ts?vue&type=script&lang=ts&external"
export * from "./HHPreadmissionForm.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__